// src/features/personSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

// Register a new person/offender
export const registerPerson = createAsyncThunk(
  'person/register',
  async (personData, { rejectWithValue }) => {
    try {
      const response = await api.post('/person/register', personData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to register person'
      );
    }
  }
);

const personSlice = createSlice({
  name: 'person',
  initialState: {
    crimeNumber: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearPersonRegistration: (state) => {
      state.crimeNumber = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerPerson.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(registerPerson.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.crimeNumber = action.payload.data?.crimeNumber || null;
        state.error = null;
      })
      .addCase(registerPerson.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearPersonRegistration } = personSlice.actions;
export default personSlice.reducer;